import { Box } from "@mui/material";
import PropTypes from "prop-types";

export default function BoxColorWrapper(props) {
  //const boxShadowString = "inset 0px 0px 3px 3px " + theme.palette.warning.main;
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        transition: "all 0.7s ease-in-out",
        alignItems: props.alignItems,
        textAlign: props.alignItems,
        paddingLeft: "10px",
        paddingTop: "1px",
        paddingBottom: "1px",
        lineHeight: "1em",
        cursor: "pointer",
        bgcolor: "info.main",
      }}>
      {props.children}
    </Box>
  );
}

BoxColorWrapper.propTypes = {
  alignItems: PropTypes.string,
  children: PropTypes.node,
};
